module.exports = __webpack_public_path__ + "img/abe2c4b.png";